/**
 * @generated SignedSource<<16958e7463b72e981425efa68865014a>>
 * @relayHash d301d91937cb2c82b91835068755d88f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f23f3a685337a2542cfc2d46f5454cbceb5b9dce29d3ce7612f6153eea817855

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AtlaskitAtlassianNavigationNav4UIQuery$variables = {
  cloudId: string;
  includeExtraMenuItems: boolean;
};
export type AtlaskitAtlassianNavigationNav4UIQuery$data = {
  readonly jira: {
    readonly navigationUIState: {
      readonly isLeftSidebarCollapsed: boolean;
    } | null | undefined;
  };
  readonly " $fragmentSpreads": FragmentRefs<"Nav4Profile">;
};
export type AtlaskitAtlassianNavigationNav4UIQuery = {
  response: AtlaskitAtlassianNavigationNav4UIQuery$data;
  variables: AtlaskitAtlassianNavigationNav4UIQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "includeExtraMenuItems"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "isLeftSidebarCollapsed"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "AtlaskitAtlassianNavigationNav4UIQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": (v1/*: any*/),
              "concreteType": "JiraNavigationUIStateUserProperty",
              "kind": "LinkedField",
              "name": "navigationUIState",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": (v2/*: any*/),
                  "action": "THROW",
                  "path": "jira.navigationUIState.isLeftSidebarCollapsed"
                }
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      },
      {
        "kind": "FragmentSpread",
        "name": "Nav4Profile"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AtlaskitAtlassianNavigationNav4UIQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraNavigationUIStateUserProperty",
            "kind": "LinkedField",
            "name": "navigationUIState",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          }
        ]
      },
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              {
                "condition": "includeExtraMenuItems",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "email"
                      }
                    ],
                    "type": "AtlassianAccountUser"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "picture"
              },
              (v3/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "f23f3a685337a2542cfc2d46f5454cbceb5b9dce29d3ce7612f6153eea817855",
    "metadata": {},
    "name": "AtlaskitAtlassianNavigationNav4UIQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "24b3a01df9cca004f2d7dc11b9fc9741";

export default node;
